app.controller('CIFConfirmation-CTRL', function ($scope, $rootScope, $routeParams, uibDateParser, deviceDetector,
    $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {

    var allPromise = $q.all([
        $scope.retrieveSessions(),
    ]);

    allPromise.then(function () {
     
    });

    $scope.submit = function () {
    }

});

